// src/handover/handoverContracts.js

/* ============ RAW CONTRACT TEXTS ============ */

export const PICKUP_CONTRACT_GE = `
TERMS AND CONDITIONS:

According to this agreement the Lessor shall transfer and the Lessee shall take a temporary hold and responsibility of the transport Vehicle (hereinafter the Vehicle), according to the following conditions: This agreement provides general terms and rules which the Lessee shall follow and apply during the Vehicle renting period.
The Lessee is obliged to pay the Lessor a rental price under the Terms and Conditions of the present Agreement.

VEHICLE CLEANLINESS CONDITION UPON PICK UP:

• If the Vehicle is washed upon pick up and returned in an unclean condition, a washing fee of 25 GEL is subject to deduction from the deposit amount, or has to be paid extra by the Lessee. If the Vehicle requires more than the usual standard cleaning on its return, the Lessee is required to pay an additional cleaning cost that should be sufficient to restore it to its pre-rental normal condition.
• The Lessee is obliged to return the Vehicle with the same fuel level it had on the pick-up time. Otherwise, the missing fuel amount is subject to a deduction from the Deposit Amount, or to be paid directly by the Lessee.
• If the Vehicle’s screen shows the remaining distance range, this latter has to be taken into consideration in order to compare the fuel levels and make the calculation.
• In case of a decrease in the remaining distance range, the missing fuel amount has to be compensated by the Lessee as follows: 1 Gel per kilometer or Mile.

RENTAL PERIOD GENERAL TERMS:

• The Lessee states that he/she is physically, mentally, and legally qualified to drive, take control and operate the above-described Vehicle.
• The Lessor states that the Vehicle is in a safe condition and free of any known defects or faults which would affect its safe operation under normal use.
• The Lessor agrees to rent the Vehicle to the Lessee for the whole rental period determined in the agreement.

MATURITY OF THE AGREEMENT:

This Agreement enters into force from the moment of its signing by The Lessee, and is valid until full fulfillment of the obligations.
The Vehicle shall be transferred to The Lessee upon signing of the present Rental Agreement.
Upon expiration of the lease term, the Lessee shall return back the Vehicle to the Lessor in the above-selected location.

VEHICLE HAND-OVER:

A Car Return Inspection Sheet that describes the condition of the Vehicle upon its handover and mentions its physical condition and clearly shows its odometer (kilometers/Miles) and all other possible alerts has to be signed by the Lessee.
If the Lessee refuses to sign the Car Return Inspection Sheet, this does not prevent in any way the Inspection Sheet with all included information, details and photos from being completely valid.
Any defect that may be discovered in the Vehicle after the signing of the Car Return Inspection Sheet shall be beyond the responsibility of the Lessor, which means that by signing the present Agreement and the Car Return Inspection Sheet, the following shall apply:
- The Lessee confirms that the condition of the Vehicle at the hand-over moment is the same as it is mentioned and shown in the Car Return Inspection Sheet.
- The Lessor shall be liberated from any liability over the correction of the defect or compensation of damages, including the one incurred towards any third party.
- The Lessee remains totally responsible and should compensate the Lessor for any damage/scratch of any kind and for any missing/malfunctioning part that may be discovered after the Hand-over of the Vehicle.
- In case any kind of ticket (Police, Parking, etc.) is received on the Vehicle after its hand-over, the Lessee remains responsible for it, and the ticket(s) amount shall be automatically deducted from the Deposit Amount.
- For the purposes of the present Agreement, it is assumed that the Lessee starts using the Vehicle immediately from the moment the present agreement is signed.
- Any lack of use and/or delayed use of the Vehicle shall not exempt the Lessee from totally paying the above-mentioned rental amount, and does not allow him to get any kind of refund, and does not even allow him to postpone the drop-off time or date.
- When returning back the Vehicle, the Lessee shall ensure at his full personal responsibility that no personal luggage/belongings are left in the Vehicle before handing it over to the Lessor. Once the Car Rental Inspection Sheet is signed, the Lessee has no longer the right to invoke and not even to claim that he forgot any belongings in the Vehicle.

RENTAL PERIOD EXTENSION:

If the Lessee desires to extend the rental period, the Parties shall mutually agree to amend the agreement or to sign a new one.
In case of extension of the rental period, the Lessee shall pay the full rental amount before the beginning of the new reservation period. Otherwise, the Lessee must drop-off the Vehicle immediately, or he will be considered possessing the Vehicle in an illegal way.

DRIVING LICENSE:

Any valid driving license which is printed in Latin or Cyrillic alphabet is acceptable on Georgian territories. An international driving license is required when the Lessee’s driving license is not written in English language.
The Lessee has to present the original and valid driving license to the Lessor when receiving the Vehicle. Otherwise, The Lessor shall not allow him to pick up the Vehicle.
If the Lessee’s national driving license includes a photo card license and a secondary paper counterpart license, both original parts are mandatory and are required when collecting the Vehicle.
The Vehicle’s driver shall keep the original and valid driving license and passport in his possession throughout the whole rental period.
If the Vehicle has been impounded by the police for any reason (such as: committing a crime, causing harm to others, in case of road accident, due to documents’ forgery, the driver didn’t possess his original and valid documents, etc...) the Lessee shall pay the total charges that will result in order to release the Vehicle, in addition to the total rental amount for the additional days in which the Vehicle remains impounded and/or the Vehicle requires to be repaired.

AGE RESTRICTIONS:

The Vehicle can be operated only by any person other than the Lessee who is over the age of 21 and has 2 years of driving experience, providing that the Lessee informs the Lessor in advance and provides him with the driver’s original passport/ID card and driving license, and receives his approval.
If the Lessee allows any other driver under the age of 21 years old to drive the Vehicle, the Lessee will be fully responsible for all expenses that may result and will be responsible towards the others including any other Vehicle involved in any type of accident.

VEHICLE CONDITION:

- The Lessee is obliged to take the Vehicle, to protect it from theft and robbery, and to preserve its maintenance in accordance with the technical characteristics.
- If at the time of drop-off, the Vehicle was found damaged, namely if a defect/harm (damage, scratches, creases, cracks, etc.) is incurred, which was not present at the time when the Car Rental Agreement was signed, the Lessee must take full responsibility and compensate the Lessor with the sufficient amount to repair the damage(s) providing that the compensation amount is not less than 100 USD for each damaged part/item.
- In the event of damage to the Vehicle, associated with its misuse, the cost of reparation has to be totally compensated by the Lessee.
- The damage to the Vehicle's tires and/or discs is not covered by the insurance and shall be the responsibility of the Lessee, regardless of the cause of the damage.
- At the end of the rental period, or in case of termination of the Agreement for any reason, the Lessee shall hand-over the Vehicle to the Lessor with all the setup, additional equipment, and accessories, in a good technical condition considering normal depreciation. Otherwise, the Lessee shall compensate the Lessor for the damage caused (100 USD or its equivalent in GEL for each damaged/missing accessory).
- In case the Vehicle keys are lost, the Lessee must pay a total amount of 400 USD (or equivalent in GEL) to the Lessor, and he shall bear the total cost of the evacuator/crane to transport the Vehicle to Tbilisi.
- In the event of a breakdown, accident, or mechanical/technical difficulties, the Lessee must inform the Lessor immediately.
- If the Vehicle breaks down due to any accident or mechanical failure or if the Vehicle was impounded, the Lessee must immediately hand-over the Vehicle keys to the Lessor, and the Lessee is prohibited from refraining from complying with this obligation. Otherwise, the key will be considered lost and a total amount of 400 USD or equivalent in GEL will be immediately deducted from the deposit amount.
- If the Vehicle breaks down for any reason due to its misuse by the Lessee, the Lessor is not responsible to replace the Vehicle with another one. In such case, the total deposit amount will be automatically deduced and the Lessor preserves the right to deprive the Lessee of the Vehicle without refunding the rest of the Rental Amount for the remaining period. This matter does not absolve the Lessee at all from the obligation of handing over the Vehicle and the keys immediately to the Lessor.
- Animals are not allowed to be in the Vehicle. If the Lessee lets any animal get in the Vehicle, he will be automatically charged a penalty fee of 100 USD in addition to a cleaning fee of 25 USD.
- If the Vehicle is not available for any reason (such as in the case of an unexpected accident, technical or mechanical failure, etc.) the Lessor preserves the right to provide the Lessee with another same-category vehicle.

THE LESSEE DECLARES THE FOLLOWING:

• His driving license is genuine and original.
• His driving license wasn’t confiscated in any country.
• There is no court decision that deprives him from the right to drive, and no court hearing related to car accident(s).
• He doesn’t have any physical or mental illness or disorder that is an impediment to driving.
• He is above 21 years old and has at least 2 years of driving experience.
• He is capable and has full authority to sign this Agreement.

N.B: IF AT ANY TIME THE INFORMATION PROVIDED ABOVE IS PROVEN INCORRECT, THE LESSEE WILL BE OBLIGED TO COMPENSATE THE LESSOR FOR ALL RESULTING DAMAGES.

RULES REGARDING FINES:

If during the rental period, the Lessee violates any parking or traffic signs, rules or regulations, he must take full responsibility and compensate all fines and tickets defined by the Lessor (according to official government websites such as www.parking.tbilisi.gov.ge, www.police.ge, etc.).
The Lessee is responsible for all toll fees, congestion charges, speeding tickets, parking fines, traffic fines, and all associated administration costs.
All fines that have been handed personally are registered in the police database on Lessee’s name and must be paid according to Georgian law before he leaves Georgian territories.

RULES REGARDING EARLY AND LATE VEHICLE DROP-OFFS:

The Vehicle must be returned on time. If there is any chance the return might be late, the Lessee should contact the Lessor immediately to inform him of the new return time and ask for his approval.
Any delay for 1 or more hours leads automatically to a 24 hours additional rental cost.
An early Vehicle return is not subject to any refund.
If the Lessor is not informed or does not agree with a late return and the Lessee returns the Vehicle after more than 3 hours, the Lessor preserves the right to apply to the law enforcement authorities and report that the Vehicle was stolen, which may result in relevant criminal liability.

PAYMENT AND DEPOSIT AMOUNT:

The Deposit Amount is 1100 GEL, and has to be blocked on the Lessee’s Credit/Debit Card.
The deposit amount shall be released no later than 45 working days after delivering back the Vehicle as long as all conditions are met.
The full amount of the lease payment has to be made in advance, upon signing this agreement, prior to the transfer of the Vehicle to the Lessee by the Lessor, by cash/non-cash payment.
The Rental Amount is paid in USD, Euro, Sterling Pound, or GEL according to Bank of Georgia (BOG) official exchange rate on the payment day.

RENTAL AMOUNT INCLUDES:

• All taxes;
• Unlimited mileage;
• Third Party Insurance coverage;

THIRD PARTY INSURANCE COVERAGE & DRIVER’S AGE:

In case of an accident, Police have to be immediately informed by the Lessee in order to make the required accident report, and the insurance company has to be informed as well.
If the Lessee does not inform the Lessor, he must take full responsibility for any harm/damage of any kind caused to the Vehicle.
The insurance does not cover accidents in case the driver is drunk or under the influence of drugs, drives in the opposite direction along a unilateral street, or has a non-valid/suspended driving license, or for any other illegal reason. In such case, the Lessee is responsible to refund the total loss and/or full damage, and he shall bear the total cost of the evacuator/crane.
The Lessee is responsible for all the received police and City Parking tickets.
The Lessee also agrees that his belongings and items left in the Vehicle at any time are not covered by insurance.
The insurance does not cover any damage/cut of the tires, windshields and interior of the Vehicle.

FULL COVERAGE INSURANCE:

If the Lessee decides to upgrade the Insurance Coverage of the Vehicle, the latter will become fully covered, providing that the Lessee immediately informs the Police, the Lessor and the Insurance company in case of any accident or damage.
In case of an accident/damage, the Lessee shall immediately stop the Vehicle and wait until Police arrive at the accident location to make the required report. Otherwise, the damage will not be covered.
The Lessee shall provide the Lessor with clear photos of the damaged part(s), and with photos of the Vehicle from all sides, as well as his exact location.

CROSSING BORDERS RESTRICTIONS:

Crossing the international Georgian borders is prohibited during the Vehicle renting period.

RESPONSIBILITIES OF THE LESSEE:

The Lessee must:

• Respect the Lessor and his managers, employees/representatives and take care of the Vehicle;
• Preserve the Vehicle from any damage and keep it safe;
• Not use the Vehicle to push, propel or tow any other vehicle, trailer, animal, or any other thing;
• Not use the Vehicle in any race or in any speed competition;
• Not use the Vehicle for any illegal activity or purpose(s);
• Not operate the Vehicle in a negligent manner;
• Preserve the Vehicle and return it in the same mechanical and technical condition as it was before receiving the Vehicle, and without damages;
• Return the Vehicle in a clean condition, so that the Lessor is able to check the Vehicle’s condition (such as damages, scratches, etc.);
• Immediately notify the Lessor if the Vehicle is damaged;
• Provide the Lessor with his phone number on which one of the following applications (WhatsApp, Viber or Telegram) is installed, providing that the phone is always connected to the internet. Otherwise, the Lessee must provide the Lessor with a Georgian number so that Parties can contact each other at any time;
• Act according to the instructions annexed to the Agreement if the Vehicle is damaged;
• Compensate the Lessor in case of any damage if the latter is not covered or is refused to be covered by insurance due to not following insurance rules and/or Lessor’s instructions and/or conditions indicated in the annex;
• Pay any fee/penalty/ticket resulting from violations of traffic rules and/or legislation during the rental period;
• Contact the 24/7 hotline phone numbers (+995 592050087 or +995 595004656) in any emergency case;
• Not consume or be under the impact of alcoholic beverages and/or narcotic substances while driving;
• Not transfer the Vehicle to any other person;
• Not sublease the Vehicle;
• Not breach the legislation of the country.

N.B: IT IS STRICTLY PROHIBITED TO USE THE VEHICLE IN SPORTS ACTIVITIES AND COMPETITIONS (INCLUDING OFF-ROAD ACTIVITIES), TO DRIVE IT IN INACCESSIBLE PLACES AND IN EXTREME WEATHER CONDITIONS, OR TOW OTHER VEHICLES, AS WELL AS FOR TEACHING PURPOSES.

In the event of such incident, the Deposit Amount will be immediately and totally deducted, and the Lessor preserves the right to deprive the Lessee of the Vehicle without refunding the rent amount for the remaining rental period, and the Lessee shall bear the total cost of the evacuator/crane.

RESTRICTED AREAS:

ABKHAZIA, SOUTH OSSETIA, LENTEKHI – USHGULI, TUSHETI, AND GODERDZI PASS (BATUMI – AKHALTSIKHE).

GOVERNING LAW AND JURISDICTION:

This Agreement and all disputes arising out of or connected with it shall be governed by and construed in accordance with the laws of Georgia at Tbilisi City Court.

FORCE-MAJEURE:

The Lessor is not responsible for non-fulfillment of obligations in case of force majeure, which includes flood, earthquake, fire, military blockade, regulations or acts of public authorities, or unexpected car accident or mechanical/technical problem to the Vehicle.

OTHER TERMS OF THE AGREEMENT:

The Agreement may be terminated early by the Lessee via call, text message, or email.
All documents, photos, information and details of any kind attached to this Agreement become an inherent part of it.

This agreement is made in two digital equal legal force copies in English language, one for each party.
`;


export const DROPOFF_CONTRACT_GE = `
`;

export const PICKUP_CONTRACT_AL = `
CAR RENTAL AGREEMENT
Republic of Albania
This Car Rental Agreement (the “Agreement”) is entered into between:
A. LESSOR
Haste LLC
Registration No.: 424255950
Phone Numbers: +995595004656 / +995592050087
(hereinafter referred to as the “Lessor”)
and
B. LESSEE
The customer whose details are indicated in the Vehicle Pick-Up Contract
(hereinafter referred to as the “Lessee”).
The Lessor and the Lessee shall hereinafter collectively be referred to as the “Parties”.
By signing the Vehicle Pick-Up Contract, the Lessee confirms that he/she has read, understood, and accepted the terms and conditions of this Agreement.
________________________________________
1. SUBJECT OF THE AGREEMENT
1.1 Under this Agreement, the Lessor grants the Lessee a temporary right to use the rented vehicle (the “Vehicle”), subject to the terms and conditions set forth herein.
1.2 The Lessee undertakes to pay the rental charges in full and comply with all obligations arising from this Agreement.
1.3 The Vehicle remains the exclusive property of the Lessor at all times.
________________________________________
2. VEHICLE CONDITION, CLEANLINESS, AND FUEL POLICY
2.1 The Vehicle is delivered in good operating condition and shall be returned in the same condition, excluding normal wear and tear.
2.2 The Lessee shall return the Vehicle in a reasonably clean condition. Excessive dirt, stains, odors, sand, animal hair, smoking residue, or abnormal cleaning requirements may result in additional cleaning charges.
2.3 The Vehicle shall be returned with the same fuel level as at the time of pick-up.
2.4 Any fuel shortage shall be charged as follows:
• EUR 20 fixed service fee; plus
• EUR 2.5 per missing liter.
2.5 Where applicable, the Vehicle’s displayed remaining driving range may be used to determine the fuel level.
________________________________________
3. RENTAL PERIOD
3.1 The rental period starts upon the signing of the Vehicle Pick-Up Contract and ends upon the return of the Vehicle to the agreed drop-off location.
3.2 The Lessee confirms that he/she is physically, mentally, and legally fit and qualified to operate the Vehicle.
3.3 The Lessor confirms that the Vehicle is delivered in a roadworthy and safe condition.
________________________________________
4. VEHICLE HAND-OVER AND RETURN
4.1 Upon delivery of the Vehicle, the Parties shall sign a Vehicle Inspection Sheet indicating the Vehicle’s condition, mileage, fuel level, visible damages, accessories, warning lights, and any additional remarks.
4.2 The signed Vehicle Inspection Sheet shall constitute conclusive evidence of the Vehicle’s condition at the time of hand-over.
4.3 Refusal by the Lessee to sign the Vehicle Inspection Sheet shall not invalidate the inspection report, photographs, videos, or any evidence prepared by the Lessor.
4.4 By signing the Vehicle Inspection Sheet, the Lessee acknowledges and accepts the Vehicle’s condition as recorded therein.
4.5 The Lessee shall be fully responsible for any loss, damage, missing accessories, fines, penalties, or violations occurring during the rental period.
4.6 The Lessee shall ensure that all personal belongings are removed from the Vehicle before return. The Lessor shall not be liable for any items left inside the Vehicle.
4.7 Failure by the Lessee to use the Vehicle, delayed use, or early return shall not entitle the Lessee to any refund, reduction, extension, or compensation.
________________________________________
5. RENTAL EXTENSION
5.1 Any extension of the rental period is subject to the prior written approval of the Lessor.
5.2 The Lessee must pay all additional rental charges before the commencement of the extended rental period.
5.3 Failure to return the Vehicle on time without the Lessor’s approval may result in additional charges and legal action.
________________________________________
6. DRIVING LICENSE REQUIREMENTS
6.1 The Lessee and any authorized driver must hold a valid driving license.
6.2 Driving licenses written in Latin or Cyrillic characters are accepted within Albanian territory.
6.3 An International Driving Permit (IDP) is mandatory when the driving license is not written in Latin characters.
6.4 The Lessee must present the original physical driving license and passport or national ID card at the time of Vehicle pick-up.
6.5 Digital copies or photographs of driving licenses shall not be accepted.
6.6 If the Vehicle is impounded due to the Lessee’s actions, negligence, violation of law, invalid documentation, or any fault attributable to the Lessee or driver, the Lessee shall bear all resulting expenses, including:
• impound fees;
• legal or administrative fees;
• towing expenses;
• repair costs;
• and additional rental charges for the entire immobilization period.
________________________________________
7. DRIVER AND AGE REQUIREMENTS
7.1 The Vehicle may only be operated by the Lessee and/or any additional driver approved in writing by the Lessor.
7.2 Any authorized driver must:
• be at least 21 years old;
• possess a valid driving license;
• and have a minimum of two (2) years of driving experience.
7.3 The Lessee must provide the Lessor with the additional driver’s original passport or ID card and driving license prior to authorization.
7.4 Drivers aged between 21 and 25 years old or between 70 and 90 years old may be subject to an additional fee of EUR 12 per day.
7.5 Adding an additional driver to the Agreement is subject to a fee of EUR 12 per day.
7.6 The Lessee shall remain fully liable for any act, omission, negligence, violation, damage, or accident caused by any authorized or unauthorized driver.
7.7 Allowing an unauthorized person to drive the Vehicle constitutes a material breach of this Agreement and may result in termination of the rental and loss of insurance coverage.
________________________________________
8. VEHICLE USE, CONDITION, AND DAMAGE
8.1 The Lessee shall use the Vehicle responsibly and in accordance with all applicable laws and regulations.
8.2 The Lessee shall take all reasonable measures to protect the Vehicle against theft, vandalism, misuse, or damage.
8.3 Any damage occurring during the rental period, including scratches, dents, cracks, interior damage, tire damage, wheel damage, or mechanical damage caused by misuse, shall be the responsibility of the Lessee unless covered by insurance.
8.4 Tire, wheel, windshield, underbody, interior, and clutch damages are not covered under standard insurance unless expressly stated otherwise.
8.5 At the end of the rental period, the Vehicle shall be returned together with all keys, documents, accessories, and additional equipment in the same condition as received, excluding normal wear and tear.
8.6 In the event of lost or damaged keys, the Lessee shall pay USD 400 (or equivalent in EUR or LEK), in addition to any towing or transportation expenses.
8.7 In the event of breakdown, accident, warning light, theft, attempted theft, or mechanical issue, the Lessee must immediately notify the Lessor.
8.8 The Lessee shall not authorize any repair, replacement, or mechanical intervention without the Lessor’s prior approval.
8.9 If the Vehicle becomes unusable due to misuse, negligence, prohibited use, or breach of this Agreement by the Lessee, the Lessor shall not be obligated to provide a replacement Vehicle or refund unused rental days.
8.10 Animals are not permitted inside the Vehicle unless expressly approved by the Lessor.
8.11 If the reserved Vehicle becomes unavailable for operational reasons, the Lessor reserves the right to provide a similar-category or upgraded replacement Vehicle.
________________________________________
9. LESSEE DECLARATIONS
The Lessee declares and warrants that:
9.1 All information and documents provided to the Lessor are true, valid, and accurate.
9.2 The driving license presented is genuine, valid, and not suspended, revoked, or confiscated.
9.3 The Lessee is not prohibited by any judicial or administrative authority from driving.
9.4 The Lessee is not under the influence of alcohol, drugs, medication, or any substance affecting driving ability.
9.5 The Lessee does not suffer from any physical or mental condition impairing the safe operation of the Vehicle.
9.6 The Lessee has full legal capacity and authority to enter into this Agreement.
9.7 Any false declaration may result in immediate termination of the rental, loss of insurance coverage, and liability for all resulting damages and expenses.
________________________________________
10. FINES, TICKETS, AND TRAFFIC VIOLATIONS
10.1 The Lessee shall be solely responsible for all traffic violations, parking violations, toll charges, congestion charges, fines, penalties, administrative fees, towing charges, and related expenses incurred during the rental period.
10.2 The Lessor reserves the right to charge the Lessee’s payment method for any unpaid fines, penalties, or related administrative expenses.
10.3 The Lessee remains responsible for all fines issued after the rental period if the violation occurred during the rental period.
10.4 The Lessee shall comply with Albanian legislation regarding the settlement of fines before leaving Albanian territory.
________________________________________
11. VEHICLE RETURN POLICY
11.1 The Vehicle must be returned on the agreed date, time, and location.
11.2 Any anticipated delay must be communicated immediately to the Lessor.
11.3 Delays exceeding one (1) hour may result in an additional full-day rental charge.
11.4 Early return of the Vehicle does not entitle the Lessee to any refund.
11.5 Failure to return the Vehicle without prior approval may result in legal proceedings and recovery actions.
________________________________________
12. PAYMENT AND SECURITY DEPOSIT
12.1 The Lessee shall pay the full rental amount in advance prior to receiving the Vehicle.
12.2 A security deposit shall be blocked or charged according to the Vehicle category and the selected insurance coverage.
12.3 The security deposit may be retained partially or fully in case of:
• damages;
• unpaid charges;
• fines;
• penalties;
• smoking violations;
• excessive cleaning;
• missing items;
• fuel shortage;
• breach of this Agreement;
• or any amount owed by the Lessee.
12.4 Deposits blocked on credit cards may take up to 45 working days to be released depending on banking procedures.
12.5 The rental amount may be paid in EUR, USD, GBP, AED, LEK, or any other currency accepted by the Lessor according to the applicable exchange rate.
________________________________________
13. RENTAL PRICE INCLUDES
Unless otherwise agreed, the rental price includes:
• applicable taxes;
• standard insurance coverage;
• unlimited mileage;
• selected extras;
• and authorized cross-border permission (if purchased).
________________________________________
14. INSURANCE TERMS
14.1 In the event of an accident, theft, attempted theft, or damage, the Lessee must immediately:
• notify the Police;
• notify the Lessor;
• and comply with insurance reporting procedures.
14.2 Failure to comply with reporting obligations may result in loss of insurance coverage.
14.3 Insurance shall not apply in cases including, but not limited to:
• driving under the influence of alcohol or drugs;
• reckless or illegal driving;
• unauthorized drivers;
• invalid or suspended driving licenses;
• prohibited use of the Vehicle;
• off-road driving;
• gross negligence;
• or breach of this Agreement.
14.4 The Lessee shall remain responsible for all police fines, parking violations, and administrative charges incurred during the rental period.
14.5 Personal belongings left inside the Vehicle are not covered by insurance.
14.6 Standard insurance does not cover tires, rims, underbody, interior, clutch, lost keys, or windshield damage unless expressly included.
________________________________________
15. FULL INSURANCE COVERAGE OPTION
15.1 If the Lessee purchases Full Insurance Coverage offered by the Lessor, the Vehicle may benefit from reduced financial liability subject to compliance with all terms and conditions.
15.2 Full Insurance Coverage shall become void if the Lessee fails to:
• immediately notify the Police and the Lessor;
• remain at the accident scene when legally required;
• cooperate with authorities and the insurance company;
• or comply with this Agreement.
15.3 The Lessee shall provide clear photographs of the Vehicle, damages, accident scene, and any involved vehicles upon request.
15.4 Full Insurance Coverage does not exempt the Lessee from liability in cases of gross negligence, prohibited use, fraud, intoxication, or breach of this Agreement.
________________________________________
16. ADDITIONAL EQUIPMENT
Additional equipment may be provided upon availability and prior request, including:
• Booster Seat – EUR 7/day
• Toddler Seat – EUR 7/day
• Infant Seat – EUR 7/day
• GPS – EUR 7/day
• Snow Chains – EUR 7/day
• Snow Tires – EUR 7/day
• Winter Package – EUR 7/day
• Bluetooth Receiver – EUR 10/day
The Lessee shall be responsible for any loss or damage to additional equipment.
________________________________________
17. CROSS-BORDER POLICY
17.1 Cross-border travel is permitted only with the Lessor’s prior written approval.
17.2 Authorized cross-border travel is limited to the following countries:
• Greece
• Kosovo
• North Macedonia
• Montenegro
17.3 Cross-border authorization is subject to an additional fee of EUR 70 per authorized country unless otherwise agreed.
17.4 Unauthorized border crossing constitutes a material breach of this Agreement and may void insurance coverage.
________________________________________
18. LESSEE OBLIGATIONS
The Lessee undertakes to:
18.1 Treat the Vehicle with due care and diligence;
18.2 Protect the Vehicle against damage, theft, misuse, and vandalism;
18.3 Return the Vehicle in the same technical and mechanical condition as received, excluding normal wear and tear;
18.4 Return the Vehicle in a sufficiently clean condition to allow inspection;
18.5 Immediately notify the Lessor in case of accident, damage, breakdown, warning lights, theft, or third-party claims;
18.6 Remain reachable throughout the rental period through a valid phone number connected to WhatsApp, Viber, Telegram, or a local Albanian number;
18.7 Follow all instructions provided by the Lessor regarding accidents, breakdowns, insurance procedures, and Vehicle handling;
18.8 Compensate the Lessor for any damage not covered by insurance;
18.9 Pay all fines, charges, penalties, and administrative fees incurred during the rental period;
18.10 Contact the emergency hotline in case of urgent assistance.
________________________________________
19. PROHIBITED USE
The Lessee shall not:
19.1 Use the Vehicle for racing, speed testing, competitions, or off-road activities;
19.2 Use the Vehicle for illegal activities;
19.3 Drive under the influence of alcohol, drugs, or prohibited substances;
19.4 Sublease, sell, pledge, or transfer the Vehicle to third parties;
19.5 Use the Vehicle for towing, pushing, or transporting prohibited goods;
19.6 Drive on non-asphalted roads, inaccessible roads, flooded areas, beaches, restricted roads, or areas prohibited by the Lessor;
19.7 Use the Vehicle for driver training purposes.
19.8 Any prohibited use may result in:
• immediate termination of the rental;
• cancellation of insurance coverage;
• forfeiture of the security deposit;
• additional penalties;
• and liability for all resulting damages and expenses.
________________________________________
20. RESTRICTED AREAS
The Vehicle is strictly prohibited from being driven in the following areas unless expressly authorized:
• Lake Bovilla Road
• Osumi Canyon – Përmet
The Lessor reserves the right to update restricted areas when necessary.
________________________________________
21. GOVERNING LAW AND JURISDICTION
This Agreement shall be governed by and construed in accordance with the laws of the Republic of Albania.
Any dispute arising out of or related to this Agreement shall fall under the exclusive jurisdiction of the competent courts of the Republic of Albania.
________________________________________
22. FORCE MAJEURE
The Lessor shall not be liable for any delay, cancellation, or inability to perform its obligations due to events beyond its reasonable control, including but not limited to:
• natural disasters;
• floods;
• earthquakes;
• fires;
• wars;
• governmental actions;
• strikes;
• border closures;
• unexpected accidents;
• or mechanical failures.
________________________________________
23. FINAL PROVISIONS
23.1 All annexes, inspection sheets, photographs, videos, reservations, invoices, and related documents form an integral part of this Agreement.
23.2 This Agreement may be executed electronically or physically and may be signed digitally.
23.3 If any provision of this Agreement is found invalid or unenforceable, the remaining provisions shall remain fully valid and enforceable.
23.4 This Agreement constitutes the entire agreement between the Parties and supersedes any prior oral or written understandings.
23.5 The Lessee confirms having carefully read and understood all provisions of this Agreement prior to signing.
________________________________________
24. DAMAGE PRICE LIST
The attached Damage Price List forms an integral part of this Agreement and applies to all damages not covered by insurance.
The Lessor reserves the right to charge actual repair costs where the repair exceeds the indicative amounts stated in the Damage Price List.

        Car Category    Car Category    Car Category
        MINI, ECONOMY   COMPACT + ELITE SUV + PEOPLE CARRIER
Nr.     SCRATCHES       SCRATCHES       SCRATCHES
1       300             375             450
2       Damaged Part    300             375             450
3       Front/Rear Bumpers      300     375             450
4       Front/Rear Clay cover   300     375             450
5       Front/Rear Doors        300     375             450
6       HOOD            DAMAGE          DAMAGE          DAMAGE
7       ROOF            400             600             950
8       Front/Rear Clay cover   300     400             500
9       Front/Rear Bumpers      350     450             550
10      Front/Rear Clay cover   300     400             600
11      Front/Rear Doors        450     600             800
12      HOOD            250             300             400
13      ROOF            200             250             350
14      Windscreen      180             230             320
15      Rear Windscreen 150             250             350
16      Side Windows    300             400             450
17      Side Mirrors    100             200             250
18      Headlights      90              150             200
19      Indicators(arrows)      100     150             250
20      TYRE            45              65              90
21      Fog Lights      600             950             1020
22      Ashtray         90              135             180
23      Transmission Damages    450     540             720
24      Plastic bumper cover    400     600             800
25      Oil Pan         45              65              90
26      Bridge          180             225             360
27      Windscreen wipers       300     350             400
28      Exhaust Pipe    70              70              70
29      Keys            250             250             250
30      Emergency Kit   300             300             300
31      Loss of Plates  150             200             250
32      Loss of Car Documents   50      70              90
33      Radio Damage    150             150             150
34      Loss of Antenna 90              150             200
35      Spare Wheel Tools       150     150             150
36      Spare Wheel     50              50              50
37      GPS Damage      75              150             250
38      Extra Cleaning  100             200             250
39      Interior Damages        50      80              100
40      AIR VENTS GRID  40              40              40
41      Cat's eye'      1.2 EURO/km     1.2 EURO/km     1.2 EURO/km
42      Coming on terrain (up to 25km)  320     410     550
43      Coming on terrain (over 25km)   135     180     270
44      Interior damages (indicator bar, etc.)  180     225     300
45      Inside mirror glass     50      90              135
46      Indside door handle     100     150             200
47      Sun visor       180             230             320
48      Gearstick       70              110             150
49      Safety seat belt        80      100             150
50      Dashboard switches      20      20              20
51      Headrest        600             800             1000
52      Loss/damage of number plate holder      450     630     810
________________________________________
SIGNATURES
By digitally signing the Vehicle Pick-Up Contract and/or this Agreement, the Lessee acknowledges and accepts all terms and conditions set forth herein.
`;

export const DROPOFF_CONTRACT_AL = `
`;

export const SUBSTITUTION_CONTRACT_GE = `
VEHICLE SUBSTITUTION ADDENDUM

This addendum records that the vehicle assigned under the active reservation is being replaced during the rental period.

1. The reservation remains active under its original dates, customer, payment terms, and deposit terms unless the parties agree separately in writing to amend them.
2. Responsibility for the originally assigned vehicle remains with the Lessee until the substitution date and time recorded in this form.
3. Responsibility for the replacement vehicle starts from the substitution date and time recorded in this form.
4. The Lessee confirms that the replacement vehicle details, plate number, fuel level, odometer, and any notes written in this form are correct at handover.
5. Any fines, damages, fuel shortages, missing equipment, or other liabilities connected to the original vehicle before the substitution timestamp remain linked to that original vehicle period.
6. Any fines, damages, fuel shortages, missing equipment, or other liabilities connected to the replacement vehicle after the substitution timestamp remain linked to the replacement vehicle period.
7. This addendum forms part of the original rental agreement and is signed digitally by the parties.
`;

export const SUBSTITUTION_CONTRACT_AL = `
VEHICLE SUBSTITUTION ADDENDUM

This addendum records that the vehicle assigned under the active reservation is being replaced during the rental period.

1. The reservation remains active under its original dates, customer, payment terms, and deposit terms unless the parties agree separately in writing to amend them.
2. Responsibility for the originally assigned vehicle remains with the Lessee until the substitution date and time recorded in this form.
3. Responsibility for the replacement vehicle starts from the substitution date and time recorded in this form.
4. The Lessee confirms that the replacement vehicle details, plate number, fuel level, odometer, and any notes written in this form are correct at handover.
5. Any fines, damages, fuel shortages, missing equipment, or other liabilities connected to the original vehicle before the substitution timestamp remain linked to that original vehicle period.
6. Any fines, damages, fuel shortages, missing equipment, or other liabilities connected to the replacement vehicle after the substitution timestamp remain linked to the replacement vehicle period.
7. This addendum forms part of the original rental agreement and is signed digitally by the parties.
`;

/* ============ NORMALIZATION ============ */

function normalizeLocation(raw) {
  const v = (raw || '').toString().trim().toUpperCase();
  // Anything that smells like Albania → AL
  if (['AL', 'Albania', 'ALB'].includes(v)) return 'AL';

  // Anything that smells like Georgia → GE
  if (['GE', 'GEORGIA', 'GEO'].includes(v)) return 'GE';

  // Default to GE so we don't blow up
  return 'GE';
}

/* ============ PUBLIC HELPERS ============ */

export function getPickupContractText(location) {
    
  const loc = normalizeLocation(location);
  return loc === 'AL' ? PICKUP_CONTRACT_AL : PICKUP_CONTRACT_GE;
}

export function getDropoffContractText(location) {
  const loc = normalizeLocation(location);
  return loc === 'AL' ? DROPOFF_CONTRACT_AL : DROPOFF_CONTRACT_GE;
}

export function getSubstitutionContractText(location) {
  const loc = normalizeLocation(location);
  return loc === 'AL' ? SUBSTITUTION_CONTRACT_AL : SUBSTITUTION_CONTRACT_GE;
}
